import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {unregister} from './registerServiceWorker';

ReactDOM.render(<App/>, document.getElementById('root'));
// registerServiceWorker();
try {
    unregister();
} catch (e) {

}


// WEBPACK FOOTER //
// ./src/index.js